import logClickEvent from '@utils/logClickEvent'
const onboarding = {
  namespaced: true,
  state: {
    tips: {
      memoHelp: localStorage.memoHelpTip || '-1', // -1 未显示 0 显示 1 已经显示
      tagHelp: localStorage.tagHelpTip || '-1',
      membershipHelp: localStorage.membershipHelpTip || '-1',
      dailyReviewHelp: localStorage.dailyReviewHelpTip || '-1',
    },
    dialogs: {
      memoHelp: localStorage.memoHelpDialog || '-1', // -1 未显示 0 显示 1 已经显示
      tagHelp: localStorage.tagHelpDialog || '-1',
      membershipHelp: localStorage.membershipHelpDialog || '-1',
      dailyReviewHelp: localStorage.dailyReviewHelpDialog || '-1',
      heatgridHelp: localStorage.heatgridHelpDialog || '-1',
    },
  },
  getters: {
    memoHelpTip: (state) => state.tips.memoHelp,
    tagHelpTip: (state) => state.tips.tagHelp,
    membershipHelpTip: (state) => state.tips.membershipHelp,
    dailyReviewHelpTip: (state) => state.tips.dailyReviewHelp,
    memoHelpDialog: (state) => state.dialogs.memoHelp,
    tagHelpDialog: (state) => state.dialogs.tagHelp,
    membershipHelpDialog: (state) => state.dialogs.membershipHelp,
    dailyReviewHelpDialog: (state) => state.dialogs.dailyReviewHelp,
    heatgridHelpDialog: (state) => state.dialogs.heatgridHelp,
  },
  mutations: {
    setMemoHelpTip(state, memoHelp) {
      state.tips.memoHelp = memoHelp
      localStorage.memoHelpTip = memoHelp
    },
    setTagHelpTip(state, tagHelp) {
      state.tips.tagHelp = tagHelp
      localStorage.tagHelpTip = tagHelp
    },
    setMembershipHelpTip(state, membershipHelp) {
      state.tips.membershipHelp = membershipHelp
      localStorage.membershipHelpTip = membershipHelp
    },
    setDailyReviewHelpTip(state, dailyReviewHelp) {
      state.tips.dailyReviewHelp = dailyReviewHelp
      localStorage.dailyReviewHelpTip = dailyReviewHelp
    },
    setMemoHelpDialog(state, memoHelp) {
      state.dialogs.memoHelp = memoHelp
      localStorage.memoHelpDialog = memoHelp
    },
    setTagHelpDialog(state, tagHelp) {
      state.dialogs.tagHelp = tagHelp
      localStorage.tagHelpDialog = tagHelp
    },
    setMembershipHelpDialog(state, membershipHelp) {
      state.dialogs.membershipHelp = membershipHelp
      localStorage.membershipHelpDialog = membershipHelp
    },
    setDailyReviewHelpDialog(state, dailyReviewHelp) {
      state.dialogs.dailyReviewHelp = dailyReviewHelp
      localStorage.dailyReviewHelpDialog = dailyReviewHelp
    },
    setHeatgridHelpDialog(state, heatgridHelp) {
      state.dialogs.heatgridHelp = heatgridHelp
      localStorage.heatgridHelpDialog = heatgridHelp
    },
  },
  actions: {
    setMemoHelpTip({ state, commit, rootGetters }, memoHelp) {
      // 已经显示过了
      if (state.tips.memoHelp == 1) {
        return
      }
      commit('setMemoHelpTip', memoHelp)
      commit('setMemoHelpDialog', memoHelp)
      logClickEvent('写卡片_提示Banner', '展示')
    },
    setTagHelpTip({ state, commit }, tagHelp) {
      // 已经显示过了
      if (state.tips.tagHelp == 1) {
        return
      }
      commit('setTagHelpTip', tagHelp)
      commit('setTagHelpDialog', tagHelp)
    },
    setMembershipHelpTip({ state, commit }, membershipHelp) {
      // 已经显示过了
      if (state.tips.membershipHelp == 1) {
        return
      }
      logClickEvent('会员_提示Banner', '展示')
      commit('setMembershipHelpTip', membershipHelp)
    },
    setDailyReviewHelpTip({ state, commit }, dailyReviewHelp) {
      // 已经显示过了
      if (state.tips.membershipHelp == 1) {
        return
      }
      logClickEvent('回顾_提示Banner', '展示')
      commit('setDailyReviewHelpTip', dailyReviewHelp)
    },
    setMemoHelpDialog({ commit }, memoHelp) {
      commit('setMemoHelpDialog', memoHelp)
      commit('setMemoHelpTip', memoHelp == 0 ? 1 : 0)
    },
    setTagHelpDialog({ commit }, tagHelp) {
      commit('setTagHelpDialog', tagHelp)
      commit('setTagHelpTip', tagHelp == 0 ? 1 : 0)
    },
    setMembershipHelpDialog({ commit }, membershipHelp) {
      commit('setMembershipHelpDialog', membershipHelp)
    },
    setDailyReviewHelpDialog({ commit }, dailyReviewHelp) {
      commit('setDailyReviewHelpDialog', dailyReviewHelp)
      commit('setDailyReviewHelpTip', dailyReviewHelp == 0 ? 1 : 0)
    },
    setHeatgridHelpDialog({ state, commit }, heatgridHelp) {
      // 已经显示过了
      if (state.tips.heatgridHelp == 1) {
        return
      }
      commit('setHeatgridHelpDialog', heatgridHelp)
    },
  },
}

export default onboarding
